import { createDeferred } from './createDeferred.mjs';

// ---------- utils
const cancelledStreamSymbol = Symbol('cancelledReadableStream');
/**
 * One-off readable stream
 */ function createReadableStream() {
    let controller = null;
    const deferred = createDeferred();
    let cancelled = false;
    const readable = new ReadableStream({
        start (c) {
            controller = c;
        },
        cancel () {
            deferred.resolve(cancelledStreamSymbol);
            cancelled = true;
        }
    });
    return {
        readable,
        controller,
        cancelledPromise: deferred.promise,
        cancelled () {
            return cancelled;
        }
    };
}
function isCancelledStreamResult(v) {
    return v === cancelledStreamSymbol;
}

export { createReadableStream, isCancelledStreamResult };
